module.exports = __webpack_public_path__ + "img/Woman-In-Yellow_working@2x.00a45c1c.png";